import React, { useEffect } from "react";
import { getEnv } from "../utils/getEnv";

export const TealiumUTagLoader = (): JSX.Element => {
    useEffect(() => {
        globalThis.utag_data = {
            page_name_test: "Freeplay Widget",
        };

        // This will work for our testing netlify sites, but we may want to expose this to the
        // one of the 'data-' vars for the widget.
        let tealStage = getEnv().REACT_APP_TEALIUM_STAGE;
        if (!tealStage || tealStage === "") {
            tealStage = "dev";
        }

        const tagType = "script";
        const newElement = document.createElement(tagType);
        newElement.src = `https://tags.tiqcdn.com/utag/twinspiresanalytics/freeplay/${tealStage}/utag.js`;
        newElement.type = "text/java" + tagType;
        newElement.async = true;
        const newHome = document.getElementsByTagName(tagType)[0];
        if (newHome && newHome.parentNode) {
            newHome.parentNode.insertBefore(newElement, newHome);
        }
    }, []);

    return <></>;
};
